module.exports = __webpack_public_path__ + "static/img/ban-5.b566ec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ban-5.png
// module id = EnSO
// module chunks = 0